export default __webpack_public_path__ + "static/media/closet2-1440w.9b185f31.png";